import { ParamMap } from '@angular/router';
import { WebAnalyticsDashboardFilters } from '../services/web-analytics.service';

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

export function toYmdUtc(d: Date): string {
  return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;
}

function parseYmd(s: string | null): Date | null {
  if (!s || !/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    return null;
  }
  const [y, m, d] = s.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d));
}

/**
 * Default sidebar/landing filter params. `daysBack` lets each page pick its
 * own window (e.g. dashboard uses 30, users uses 7). appId is intentionally
 * omitted: empty appId means "all apps" everywhere.
 */
export function defaultFilterQueryParams(daysBack = 7): Record<string, string> {
  const end = new Date();
  const start = new Date();
  start.setUTCDate(start.getUTCDate() - (daysBack - 1));
  return {
    startDate: toYmdUtc(start),
    endDate: toYmdUtc(end),
  };
}

export function dashboardFiltersFromQuery(q: ParamMap): WebAnalyticsDashboardFilters | null {
  const appId = (q.get('appId') ?? '').trim();
  const startDate = parseYmd(q.get('startDate'));
  const endDate = parseYmd(q.get('endDate'));
  if (!startDate || !endDate) {
    return null;
  }
  return {
    appId,
    startDate,
    endDate,
    filterEventType: q.get('filterEventType') ?? '',
    filterUsername: q.get('filterUsername') ?? '',
    filterCountry: q.get('filterCountry') ?? '',
    filterBrowser: q.get('filterBrowser') ?? '',
    filterOs: q.get('filterOs') ?? '',
    filterDevice: q.get('filterDevice') ?? '',
    filterCity: q.get('filterCity') ?? '',
    filterPath: q.get('filterPath') ?? '',
  };
}

export function queryParamsFromDashboardFilters(
  f: WebAnalyticsDashboardFilters,
): Record<string, string | undefined> {
  return {
    appId: emptyToUndef(f.appId),
    startDate: f.startDate ? toYmdUtc(f.startDate) : undefined,
    endDate: f.endDate ? toYmdUtc(f.endDate) : undefined,
    filterEventType: emptyToUndef(f.filterEventType),
    filterUsername: emptyToUndef(f.filterUsername),
    filterCountry: emptyToUndef(f.filterCountry),
    filterBrowser: emptyToUndef(f.filterBrowser),
    filterOs: emptyToUndef(f.filterOs),
    filterDevice: emptyToUndef(f.filterDevice),
    filterCity: emptyToUndef(f.filterCity),
    filterPath: emptyToUndef(f.filterPath),
  };
}

function emptyToUndef(s: string | undefined): string | undefined {
  const t = (s ?? '').trim();
  return t === '' ? undefined : t;
}
